import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: 'fas fa-chalkboard-teacher',
      title: 'دعم شخصي يوميًا',
      description: 'من مشرفين ومشرفات هيمشوا معاك خطوة بخطوة'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'كورسات مجانية',
      description: 'لتطوير موهبتك وتحويلها لاحتراف'
    },
    {
      icon: 'fas fa-trophy',
      title: 'مسابقات وجوايز',
      description: 'حقيقية سواء أونلاين أو على أرض الواقع'
    },
    {
      icon: 'fas fa-globe',
      title: 'عرض موهبتك',
      description: 'على موقعنا الرسمي قدام آلاف المتابعين'
    },
    {
      icon: 'fas fa-book',
      title: 'نشر كتبك',
      description: 'ككاتب بأقل التكاليف وجودة عالية'
    },
    {
      icon: 'fas fa-palette',
      title: 'عرض أعمالك الفنية',
      description: 'ونوصل شغلك للناس ونخلي اسمك معروف'
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <h2 className="section-title">ليه تختار تكون من عيلتنا؟</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <i className={feature.icon}></i>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
